module.exports = __webpack_public_path__ + "media/images/img-hobby-5-525b5740.jpg";